// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import alertCircleIcon from "@/assets/icons/alert-circle.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type AlertCircleIconProps = Omit<IconProps, "name">;

export function AlertCircleIcon(props: AlertCircleIconProps): React.ReactNode {
  return <Icon name={alertCircleIcon} {...props} />;
}
